import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../redux/actions/authActions";
import { persistor } from "../../redux/store";
// import Toast from "./Toast";

const Logout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    persistor.purge();
    // Toast.success('Logout');
    // navigate('/login');
    setTimeout(() => {
      navigate("/login");
    }, 300);
  };

  return handleLogout;
};

export default Logout;
